import { AnyAction, ThunkDispatch, configureStore } from '@reduxjs/toolkit';
import UserAccountReducer from './UserSlice';
import BibleStudyReducer from './BibleStudySlice';
import FellowshipReducer from './FellowshipSlice';

const reducer = {
    UserAccount: UserAccountReducer,
    BibleStudy: BibleStudyReducer,
    Fellowship: FellowshipReducer,
  }

 const Store = configureStore({ 
    reducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(), 
});

export type RootState = ReturnType<typeof Store.getState>

export type AppDispatchType = typeof Store.dispatch;

export default Store;